import $ from 'jquery';
import runOnVisible from '../runner-visible';
const baseClass = 'page-header-slider--gallery';
const swiperBreakpoint = '767px';

class GallerySlider {
  constructor(el) {
    this.el = el;
    this.swiper = null;
    this.swiperThumbs = null;
    this._sliderActivated = false;

    this.$items = $(el).find(`.swiper-slide`);
    this.$swiperContainer = $(el).find('.swiper-container--main');
    this.$swiperMedia = $(el).find('.page-header-slider__pagination .page-header-slider_media');
    this.$swiperSlideMain = $(el).find('.swiper-container--main .swiper-slide');

    this.$swiperContainerThumb = $(el).find('.page-header-slider__pagination');
    this.$swiperPrev = $(el).find('.swiper-button-prev');
    this.$swiperNext = $(el).find('.swiper-button-next');
    this.$btnToggleInfo = $(el).find(`.btn--slider-info`);
    this.$mobileGallery = $(el).next();
    this.$btnCloseOverlay = $(el).find('.btn--close-overlay');
    this.$btnFullscreen = $(el).find('.btn--fullscreen');
    this.$btnFullscreenClose = $(el).find('.btn--fullscreen-close');

    runOnVisible(this.el, async () => {
      await this.initSlideshow();
    });
  }


  async initSlideshow() {
    if (this.$items.length < 2) {
      return;
    }

    await this.toggleSlideInfo();
    await this.mobileMedia();
    await this.closeOverlay();
    await this.fullscreenMode();
    await this.fullscreenModeClose();

    const {
      default: Swiper,
      // Autoplay: SwiperAutoplay,
      Navigation: SwiperNavigation,
      Thumbs: SwiperThumbs
    } = await import('swiper/core');

    Swiper.use([SwiperNavigation, SwiperThumbs]);

    this.swiperThumbs = new Swiper(this.$swiperContainerThumb[0], {
      slidesPerView: 'auto',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      initialSlide: 3,
      watchOverflow: true,
      loop: false,
      centeredSlides: true
    });

    this.swiper = new Swiper(this.$swiperContainer[0], {
      // @see https://swiperjs.com/swiper-api
      slidesPerView:'auto',
      loop: true,
      navigation: {
        prevEl: this.$swiperPrev[0],
        nextEl: this.$swiperNext[0],
      },
      speed: (1000 * (5 / 8)),

      thumbs: {
        swiper: this.swiperThumbs,
      }
    });

    this.swiper.on('slideChange',() => {
      this.$swiperContainer.find('.swiper-slide').removeClass('swiper-slide--open-info');
    });

    this.swiperThumbs.on('slideChange',(item) => {
      this.swiper.slideTo(item.activeIndex);
    });

    this.swiper.on('slideNextTransitionEnd',() => {
      this.$swiperContainer.find('.swiper-slide-active video').trigger('click');
    });

    this._sliderActivated = true;
  }

  mobileMedia() {
    const $window = $(window);
    let count = 1;
    let maxVisiblelMedia = 6;
    let countHidden = 0;
    let getMediaType = [];

    for(let item of this.$swiperSlideMain) {
      let mediaElement = 'image';
      if ($(item).find('video').length === 1) {
        mediaElement = 'video';
      }

      getMediaType.push(mediaElement);
    }


    let countslides = 0;

    for(let item of this.$swiperMedia) {
      let classes = 'image-gallery__item';
      const img = $(item).clone();
      let countMedia = null;
      let randomSpeed = Math.floor(Math.random() * 10) + 5;

      if (getMediaType[countslides] === 'video') {
        classes += ' image-gallery__item--video';
      }

      if (count === maxVisiblelMedia) {
        countMedia = $(`<div class="image-gallery--count"></div>`);
        classes += ' image-gallery__item--show-more';
      }

      if (count > maxVisiblelMedia) {
        ++countHidden;
      }

      if (count % 3 === 0) {
        classes += ' image-gallery__item--full-width';
      }

      if (count <= maxVisiblelMedia) {
        const wrapper = $(`<div data-speed="${randomSpeed}" class="${classes}"></div>`);
        wrapper.append(img);

        if (count === maxVisiblelMedia) {
          img.parent().append(countMedia);
        }

        wrapper.appendTo(this.$mobileGallery);
      }

      ++count;
      ++countslides;
    }

    $(this.el).next().find(`.image-gallery--count`).text(`+${countHidden}`);

    this.$mobileGallery.find('.image-gallery__item--show-more').click(() => {
      this.$mobileGallery.find('.image-gallery__item').removeClass('image-gallery__item--hidden')
    });

    this.$mobileGallery.find('.image-gallery__item').click((item) => {
      this.swiper.slideTo($(item.currentTarget).index());
      this.swiperThumbs.slideTo($(item.currentTarget).index());

      setTimeout(() => {
        this.swiper.update();
        this.swiperThumbs.update();
      }, 250);

      $(this.el).addClass('is-visible');
      $('body').addClass('body-overflow-hidden');
    });

    $(window).scroll(() => {
      $(this.el).next().find('.image-gallery__item img').each(function() {
        const $bgobj = $(this);
        let yPos = -($window.scrollTop() / $bgobj.closest('.image-gallery__item').data('speed'));

        if (yPos >= -60 && yPos <= 60) {
          let coords = 'center ' + yPos + 'px';
          $bgobj.css({ objectPosition: coords });
        }
      });
    });
  }

  toggleSlideInfo() {
    this.$btnToggleInfo.click(() => {
      this.$swiperContainer.find('.swiper-slide-active').toggleClass('swiper-slide--open-info');
      let infoContainer = this.$swiperContainer.find('.swiper-slide-active .page-header-slider__inner');
      let infoContainerInner = this.$swiperContainer.find('.swiper-slide-active .page-header-slider__main');
      infoContainerInner.css(`--max-height`, `${infoContainer[0].clientHeight}px`);
    });

    $(window).resize(() => {
      let infoContainer = this.$swiperContainer.find('.swiper-slide-active .page-header-slider__inner');
      let infoContainerInner = this.$swiperContainer.find('.swiper-slide-active .page-header-slider__main');
      infoContainerInner.css(`--max-height`, `${infoContainer[0].clientHeight}px`);
    });
  }

  closeOverlay() {
    this.$btnCloseOverlay.click(() => {
      $(this.el).removeClass('is-visible');
      $('body').removeClass('body-overflow-hidden');
    });
  }

  destroySlider() {
    if (this._sliderActivated === false || this.$items.length < 2) {
      return;
    }

    this.swiper.destroy();
    this.swiper = null;

    this.swiperThumbs.destroy();
    this.swiperThumbs = null;

    this._sliderActivated = false;
  }

  fullscreenMode() {
    this.$btnFullscreen.click(() => {
      $(this.el).addClass(`${baseClass}-fullscreen`);
      $('body').addClass('body-overflow-hidden');

      setTimeout(() => {
        this.swiper.update();
        this.swiperThumbs.update();
      }, 100);
    });
  }

  fullscreenModeClose() {
    this.$btnFullscreenClose.click(() => {
      $(this.el).removeClass(`${baseClass}-fullscreen`);
      $('body').removeClass('body-overflow-hidden');

      setTimeout(() => {
        this.swiper.update();
        this.swiperThumbs.update();
      }, 100);
    });
  }

}

function init() {
  $(`.${baseClass}`).each((i, el) => new GallerySlider(el));
}

export default {
  init,
};
